<script lang="ts">
  import { copy } from "../lib/stores/copy";
  import { route, setPage } from "../lib/stores/route";
  import ReceiptData from "./ReceiptData.svelte";
  import { countryStore } from "../lib/stores/country";
  import { receiptDataCountries } from "../lib/constants/countries";
  import { isPrimaryCampaign } from "../lib/constants/countries";
  import ReceiptUploader from "./Input/ReceiptUploader.svelte";

  export let setType: (type: 'code' | 'receipt') => void;

  // We only get receipt data for CA or MX
  let state: "receipt-data" | "upload" = isPrimaryCampaign && receiptDataCountries.includes($countryStore || "") ? "receipt-data" : "upload";

  if ($countryStore === "US") {
    setPage("error");
  }

  const showUploader = () => state = "upload";

  export let toggleType: () => void;
</script>

<main class="flex-col grow relative bg-dark" class:hidden={$route.isLoading}>
  <div class="bg-cover bg-no-repeat bg-[center_top] bg-[url('/bg/mobile-bg5.webp')] tabletLg:bg-none tabletLg:bg-dark px-[8px] py-[36px] pb-[calc(118px+1rem)] laptop:pb-8 h-full">
    <div class={[
      "absolute w-full z-[1] hidden tabletLg:block top-0",
      "before:content-[''] before:absolute before:bottom-0 before:left-0 before:right-0 before:h-[100px]",
      "before:bg-gradient-to-b before:from-transparent before:to-dark",
      "before:pointer-events-none"
    ].join(' ')}>
      <img src="/bg/primary-bg.webp" alt="" class="w-full h-full object-cover">
    </div>
    <div class="relative z-[2]">
      {#if state === "receipt-data"}
        <ReceiptData {showUploader} {toggleType} />
      {:else if state === "upload"}
        <form class="max-w-[1100px] mx-auto" on:submit|preventDefault>
          <div class="bg-black/50 rounded-[12px] px-[16px] py-[32px] mt-[32px]">
            <div class="text-center">
              <h1 class="font-MrEavesXLSanNarOTUltra flex flex-col items-center text-primary whitespace-normal leading-[0.75] uppercase mb-[14px] tablet:block tablet:whitespace-nowrap laptop:mb-[20px] {$copy.receipt.titleTextClasses}">
                {@html $copy.receipt.title}
              </h1>
            </div>
            <div class="text-center">
              <div class="font-MrEavesXLSanNarOTUltra text-white font-black leading-[0.9] uppercase text-[16px] mb-[16px] mobileS:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
                {@html $copy.receipt.subtitle}
              </div>
              {#if isPrimaryCampaign}
                <div class="font-MrEavesXLSanNarOT text-white font-normal leading-[0.9] text-[14px] mb-[4px] mobileS:text-[16px] mobile:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
                  {$copy.receipt.noReceiptTryCode.initial} <a href="/" on:click|preventDefault={toggleType} class="underline">{$copy.receipt.noReceiptTryCode.linked}</a>. 
                </div>
              {/if}
              <div class="font-MrEavesXLSanNarOT text-white font-normal leading-[0.9] text-[14px] mb-[4px] mobileS:text-[16px] mobile:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
                {@html $copy.receipt.info}
              </div>
              {#if !isPrimaryCampaign}
                <div class="font-MrEavesXLSanNarOT text-[18px] text-white text-center laptop:text-[15px] desktop:text-[18px] desktopLg:text-[21px]">
                  {$copy.code.support.haveCode}
                  <a href="/" on:click|preventDefault={() => setType("code")} class="underline">
                    {$copy.code.support.link}
                  </a>
                </div>
              {/if}
              <div class="font-MrEavesXLSanNarOTUltra text-white font-black leading-[0.9] uppercase text-[16px] mb-[16px] mt-[24px] mobileS:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px] tablet:mt-[38px]">
                {$copy.receipt.guidelinesTitle}
              </div>
              <div class="max-w-[600px] mx-auto px-[12px] laptop:max-w-[864px]">
                <div class="relative font-MrEavesXLSanNarOT text-white text-left font-normal mb-[24px] leading-[0.9] text-[14px] mobileS:text-[16px] mobile:text-[20px] tablet:text-[24px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
                  {$copy.receipt.guidelineIntro1} {$copy.receipt.guidelineIntroLink} {$copy.receipt.guidelineIntro2}
                </div>
                <ul class="font-MrEavesXLSanNarOT text-white font-normal list-disc text-left pl-[42px] leading-[0.9] text-[14px] mb-[4px] mobileS:text-[16px] mobile:text-[20px] tablet:text-[24px] tablet:pl-[64px] laptop:text-[26px] desktop:text-[30px] desktopLg:text-[37px]">
                  {#each $copy.receipt.guidelinesList as guideline}
                    <li class="mb-[2px]">{guideline}</li>
                  {/each}
                </ul>
              </div>
            </div>
            <div class="relative">
              <ReceiptUploader />
            </div>
          </div>
        </form>
      {/if}
    </div>
  </div>
</main>
